import { render, staticRenderFns } from "./nursePresAddJm.vue?vue&type=template&id=2f97472e&scoped=true"
import script from "./nursePresAddJm.vue?vue&type=script&lang=ts"
export * from "./nursePresAddJm.vue?vue&type=script&lang=ts"
import style0 from "./nursePresAddJm.vue?vue&type=style&index=0&id=2f97472e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97472e",
  null
  
)

export default component.exports